<template>
    <a :href="link" class="close absolute no-underline theme-ui-text-color">
        <i class="theme-question-shadow fa fa-times shadow-text-none"></i>
    </a>
</template>

<script>
export default {
    props: {
        url: String,

        embed: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            link: '/'
        }
    },

    mounted() {
        this.setLink()
    },

    methods: {
        setLink() {
            if (this.url) {
                this.link = this.url
            } else {
                this.link = '/'
            }

            if (this.embed) {
                this.link = `${process.env.VUE_APP_ROOT_URL}embed/${this.embed}`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.close {
    cursor: pointer;
    top: 0;
    right: 0;
    font-size: 1.32rem;
    line-height: 0;
    -webkit-transition: opacity 0.15s;
    transition: opacity 0.15s;
    background-color: transparent;
    border-bottom-left-radius: 0.5rem;
    width: 1.5em;
    height: 1.5em;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    opacity: 0.9;

    &:hover {
        opacity: 1;
    }
}
</style>
